import { reactive } from 'vue'
import api from '@/api'
import { swalSuccess, swalError, env } from '@/utils'

export function useStart() {
  /** 無料利用フォーム */
  const startForm = reactive(new StartForm())

  /** 無料で始める */
  function start() {
    api.user
      .start(startForm)
      .then(data => {
        if (process.env.NODE_ENV === 'production') {
          // 本番環境の場合は /start_complete.php へ遷移
          location.href = `/start_complete.php?cd=${data.bookHash}`
        } else if (process.env.NODE_ENV === 'development') {
          // 開発環境の場合はダイアログを表示 ※localhost環境上に存在しないページのため代替処置
          swalSuccess.fire({
            title: 'メールを送信しました',
            html: '<b>このダイアログは開発環境でのみ表示しています。</b><br>本番環境では <code>/start_complete.php</code> へ遷移します。',
          })
        }
      })
      .catch(err => {
        swalError.fire({ text: err })
      })
  }

  return { startForm, start }
}

export class StartForm {
  email: string
  constructor() {
    this.email = ''
  }
  clear() {
    this.email = ''
  }
}
